'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var cx = require('classnames');
var grid_module = require('./grid.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var GridCtx = react.createContext(1);
var Grid = react.forwardRef(function Grid(_a, ref) {
    var _b;
    var _c = _a.items, items = _c === void 0 ? [] : _c, cols = _a.cols, _d = _a.gap, gap = _d === void 0 ? 3 : _d, _e = _a.className, className = _e === void 0 ? '' : _e, _f = _a.render, render = _f === void 0 ? function (_item) { return jsxRuntime.jsx(jsxRuntime.Fragment, {}); } : _f, children = _a.children, renderAdditionalRowContent = _a.renderAdditionalRowContent, otherProps = tslib.__rest(_a, ["items", "cols", "gap", "className", "render", "children", "renderAdditionalRowContent"]);
    var itemsMatrix = react.useMemo(function () {
        if (!cols)
            return items;
        if (cols === 1)
            return items.map(function (item) { return [item]; });
        var rows = Math.ceil(((items === null || items === void 0 ? void 0 : items.length) || 0) / cols);
        var rowItems = [];
        for (var row = 0; row < rows; row++) {
            var colItems = items.slice(cols * row, cols * (row + 1));
            rowItems.push(colItems);
        }
        return rowItems;
    }, [cols, items]);
    // Resolve Classnames
    var gridClassName = cx__default.default(grid_module.default['grid'], (_b = {}, _b[grid_module.default["grid--cols-".concat(cols)]] = !!cols, _b), grid_module.default["grid--gap-".concat(gap)], className);
    // Render Props
    var renderFunc = typeof children === 'function' ? children : render;
    var renderRow = function (itemsToRender, rowIndex) {
        if (rowIndex === void 0) { rowIndex = 0; }
        return (jsxRuntime.jsx("div", tslib.__assign({ className: grid_module.default['grid__row'], role: "row" }, { children: itemsToRender.map(function (item, colIndx) { return (jsxRuntime.jsx(react.Fragment, { children: jsxRuntime.jsx(GridCtx.Provider, tslib.__assign({ value: colIndx + 1 }, { children: renderFunc(item, rowIndex * (cols || 0) + colIndx) })) }, colIndx)); }) })));
    };
    return (jsxRuntime.jsx("div", tslib.__assign({ className: gridClassName, role: "grid", ref: ref }, otherProps, { children: cols
            ? itemsMatrix.map(function (rowItems, rowIndex) { return (jsxRuntime.jsxs(react.Fragment, { children: [renderRow(rowItems, rowIndex), renderAdditionalRowContent && (jsxRuntime.jsx("div", tslib.__assign({ className: grid_module.default['grid__additional_content'] }, { children: renderAdditionalRowContent({
                            rowIndex: rowIndex,
                            matrixLength: itemsMatrix.length
                        }) })))] }, rowIndex)); })
            : renderRow(items) })));
});
var Grid$1 = Grid;

exports.GridCtx = GridCtx;
exports.default = Grid$1;
//# sourceMappingURL=Grid.js.map
